import { Icons } from '../../ui/Icons';
import { AccountCreationConfig } from '../../../types';

interface AccountPromptProps {
  config: AccountCreationConfig;
  isAuthenticated: boolean;
  onSignup: () => void;
  onContinue: () => void;
}

export const AccountPrompt = ({
  config,
  isAuthenticated,
  onSignup,
  onContinue
}: AccountPromptProps) => {
  if (isAuthenticated) {
    return (
      <div className="text-center py-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icons.Check className="w-8 h-8 text-green-600" />
        </div>
        <h3 className="text-xl font-bold text-gray-800 mb-2">You're Already Signed In!</h3>
        <p className="text-gray-600 mb-6">
          Great news - your progress is being saved automatically.
        </p>
        <button
          onClick={onContinue}
          className="w-full py-3 bg-primary text-white font-bold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          Continue Course
          <Icons.ArrowRight className="w-5 h-5" />
        </button>
      </div>
    );
  }

  const defaultBenefits = [
    'Save your progress across all devices',
    'Earn XP and unlock achievements',
    'Track your learning journey',
    'Get personalized recommendations'
  ];

  const benefits = config.benefits?.length ? config.benefits : defaultBenefits;

  return (
    <div className="space-y-6">
      <div className="text-center">
        <h3 className="text-xl font-bold text-gray-800 mb-2">
          Create a Free Account
        </h3>
        <p className="text-gray-600">
          Join our community and unlock these benefits:
        </p>
      </div>

      <ul className="space-y-3">
        {benefits.map((benefit, index) => (
          <li key={index} className="flex items-start gap-3">
            <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
              <Icons.Check className="w-3 h-3 text-green-600" />
            </div>
            <span className="text-gray-700">{benefit}</span>
          </li>
        ))}
      </ul>

      <div className="space-y-3">
        <button
          onClick={onSignup}
          className="w-full py-3 bg-primary text-white font-bold rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2"
        >
          <Icons.UserPlus className="w-5 h-5" />
          Create Free Account
        </button>
        <button
          onClick={onContinue}
          className="w-full py-3 text-gray-600 hover:text-gray-800 font-medium transition-colors"
        >
          Continue without account
        </button>
      </div>
    </div>
  );
};
